import React from "react";
import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-solid.css";
import { IconButton } from "../components/buttons/icon-button";

interface ScrollBottomProps {
  isVisible: boolean;
  onClick?: () => void;
}

const buttonContainer = "flex w-[36px] h-[36px] p-2 absolute right-[10px] bottom-[10px]";
const iconContainer = "flex flex-col w-[20px] h-[20px]";

export const PropertyPalScrollBottom: React.FC<ScrollBottomProps> = ({ isVisible, onClick }) => {
  if (!isVisible) return null;

  return (
    <IconButton
      icon={<i className="fa-sharp fa-solid fa-arrow-down text-base" />}
      ariaLabel="Scroll to bottom"
      onClick={onClick}
      buttonClassName={buttonContainer}
      iconClassName={iconContainer}
      isActive={isVisible}
    />
  );
};
